import type { ComponentProps } from 'react';

import { Text } from './Text';

type TextBaseProps = Omit<ComponentProps<typeof Text>, 'variant'>;

export const Heading1 = (props: TextBaseProps) => {
    return <Text variant="h1" {...props} />;
};

export const Heading2 = (props: TextBaseProps) => {
    return <Text variant="h2" {...props} />;
};

export const Heading3 = (props: TextBaseProps) => {
    return <Text variant="h3" {...props} />;
};

export const Heading4 = (props: TextBaseProps) => {
    return <Text variant="h4" {...props} />;
};

export const Heading5 = (props: TextBaseProps) => {
    return <Text variant="h5" {...props} />;
};

export const Heading6 = (props: TextBaseProps) => {
    return <Text variant="h6" {...props} />;
};
